"use strict";

exports.__esModule = true;
exports.OpenDashboardActionElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _System = require("../../../System");
var _Core = require("../../Core");
var _DeviceContext = require("../../Device/DeviceContext/DeviceContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Provides a function to a render prop which opens the dashboard
 * screen for the selected dashboard
 */
var OpenDashboardActionElement = exports.OpenDashboardActionElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var urlFilter = _react["default"].useContext(_Core.URLFilterContext);
  var filters = urlFilter.filters;
  var getURL = function getURL() {
    var id = props.dashboardID;
    var selectedDevices = device ? [device.uuid] : filters.devices;
    if (id) {
      return (0, _System.getScreenURL)("Dashboard", {
        id: id
      }, {
        devices: selectedDevices
      });
    } else {
      return (0, _System.getScreenURL)("DashboardList");
    }
  };
  var invoke = function invoke() {
    props.navigate(getURL());
  };
  var childProps = {
    getURL: getURL,
    invoke: invoke
  };
  return props.children(childProps);
});